import { useLayoutEffect, useRef, useState } from 'react';

import { TextLink } from '@/components/text-link';

import styles from './styles.module.scss';
import type { Component } from './types';

export const ClampTextWithReadmoreLink: Component = ({
  text,
  clampLine,
  fontSizePx,
  lineHeightPx,
  redirectLink,
  textClassName,
}) => {
  const averageCharWidthFactor = 0.6;
  const divRef = useRef<HTMLDivElement>(null);
  const [truncateText, setTruncateText] = useState(text);

  useLayoutEffect(() => {
    if (divRef.current) {
      const rect = divRef.current.getBoundingClientRect();

      const averageCharWidth = fontSizePx * averageCharWidthFactor;
      const charsPerLine = Math.floor(rect.width / averageCharWidth);

      const maxChars = (charsPerLine * clampLine);

      if (text.length < maxChars) {
        return;
      }

      const wordList = text.split(' ');

      let truncateTextLen = 0;
      let indexToTruncate = 0;

      for (let i = 0; i < wordList.length; i += 1) {
        truncateTextLen += wordList[i].length + 1;

        if (truncateTextLen > maxChars) {
          indexToTruncate = i;
          break;
        }
      }

      const updatedText = wordList.slice(0, indexToTruncate).join(' ');

      setTruncateText(updatedText);
    }
  }, [text, clampLine, fontSizePx]);

  return (
    <div
      ref={divRef}
      className={textClassName}
      style={{
        fontSize: fontSizePx,
        lineHeight: lineHeightPx / fontSizePx,
      }}>
      {truncateText}
      {'... '}
      <TextLink
        className={styles.textRedirectLink}
        href={redirectLink}
        text="Read More" />
    </div>
  );
};
